/**
 * 菜单管理 API
 * 对应 erp-service (7091) - 使用 /menu 单数路由
 * 仅保留后端已实现的 9 个接口
 */

import { unifiedApi } from '@/utils/unifiedApi';
import handleApiResponse from '@/utils/apiResponseHandler';
import type {
  MenuItem,
  MenuFormData,
  MenuTreeNode,
  UserMenuItem,
} from './types';

/** 获取用户菜单（侧边栏渲染用） */
export const getUserMenus = (params?: { work_mode?: string }) =>
  handleApiResponse(
    unifiedApi.service('menu').get<{ data: UserMenuItem[]; count: number }>('/menu/user', { params })
  );

/** 获取菜单树（管理页面用，含禁用菜单） */
export const getMenuTree = (params?: { work_mode?: string }) =>
  handleApiResponse(
    unifiedApi.service('menu').get<{ data: MenuItem[]; count: number }>('/menu/tree', { params })
  );

/** 获取菜单详情 */
export const getMenuDetail = (id: number) =>
  handleApiResponse(
    unifiedApi.service('menu').get<{ data: MenuItem; count: number }>(`/menu/${id}`)
  );

/** 创建菜单 */
export const createMenu = (data: MenuFormData) =>
  handleApiResponse(
    unifiedApi.service('menu').post<{ data: MenuItem; count: number }>('/menu', data)
  );

/** 更新菜单 */
export const updateMenu = (id: number, data: Partial<MenuFormData>) =>
  handleApiResponse(
    unifiedApi.service('menu').put<{ data: MenuItem; count: number }>(`/menu/${id}`, data)
  );

/** 删除菜单（递归级联删除子孙） */
export const deleteMenu = (id: number) =>
  handleApiResponse(
    unifiedApi.service('menu').delete<{ data: null; count: number }>(`/menu/${id}`)
  );

/** 移动菜单（调整父级和排序） */
export const moveMenu = (id: number, parent_id?: number, sort_order?: number) =>
  handleApiResponse(
    unifiedApi.service('menu').put<{ data: null; count: number }>(`/menu/${id}/move`, { parent_id, sort_order })
  );

/** 获取角色菜单 ID 列表 */
export const getRoleMenus = (roleId: string) =>
  handleApiResponse(
    unifiedApi.service('menu').get<{ data: number[]; count: number }>(`/menu/role/${roleId}`)
  );

/** 设置角色菜单权限 */
export const setRoleMenus = (roleId: string, menuIds: number[]) =>
  handleApiResponse(
    unifiedApi.service('menu').put<{ data: null; count: number }>(`/menu/role/${roleId}`, { menu_ids: menuIds })
  );

/** 菜单 API 对象 */
export const menuApi = {
  getUserMenus,
  getMenuTree,
  getMenuDetail,
  createMenu,
  updateMenu,
  deleteMenu,
  moveMenu,
  getRoleMenus,
  setRoleMenus,
};

export default menuApi;
